export default __webpack_public_path__ + "static/Outfit-Medium-de039feef3a44c1e4fa853679d7a92b3.woff2";